export default __webpack_public_path__ + "static/media/guide0302_m.d35a37cf.jpg";